import Tooltip, { TooltipProps } from "../Tooltip";
import "./style.css";
export interface PopoverProps extends TooltipProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  children: React.ReactElement<any, string | React.JSXElementConstructor<any>>;
  /**
   * 弹出框内容
   */
  content: React.ReactNode;
  /**
   * 弹出框位置
   */
  placement?: "top" | "left" | "right" | "bottom" | "topLeft" | "topRight" | "bottomLeft" | "bottomRight" | "leftTop" | "leftBottom" | "rightTop" | "rightBottom";
  className?: string;
}

function Popover(props: PopoverProps) {
  const { placement = "top", className, ...restProps } = props;
  return (
    <Tooltip {...restProps} arrow={false} content={props.content} placement={placement} className={`popover-container ${className ? className : ""}`}>
      {props.children}
    </Tooltip>
  );
}

export default Popover;
